import { Header } from "../../models/Header";
import { categorie, codeAct, collection, departement, description, fournisseur, p2ParJour, produit, qte, ventes } from "./columns";

export const collectionHeaders: Header[] = [
    { ...fournisseur, field: "fournisseur.four_nom_aff" },
    { ...description, field: "modele.mod_descr" },
    { ...departement, field: "departement.dept_nom" },
    { ...categorie, field: "categorie.cat_descr" },
    produit,
    codeAct,
    collection,
    ventes,
    qte,
    p2ParJour
]